/** Settings payout bank details */
export const MERCHANT_SETTINGS_PAYOUT_PATH = '/merchant/settings/payout'

export const MERCHANT_SETTINGS_PAYOUT = {
  pageTitle: 'Payment Methods',
  subtitle: 'Link the Nigerian bank account where payouts should be sent.',
  saveLabel: 'Save payout account',
  successMessage: 'Payout bank details saved.',
}
